import { render, staticRenderFns } from "./settingsTemplateConfigDetail.vue?vue&type=template&id=ced35c2e&scoped=true"
import script from "./settingsTemplateConfigDetail.vue?vue&type=script&lang=js"
export * from "./settingsTemplateConfigDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced35c2e",
  null
  
)

export default component.exports